import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { VImg, VProgressCircular } from 'vuetify/lib'

import './ProgressoForm.scss'
import { SituacaoPreAnalise } from '@/constants'
import { CreditoImobiliarioService } from '@/services'

@Component({})
export class ProgressoForm extends Vue {
	@Prop({ type: Number }) value!: number
	@Prop({ type: String }) image!: string
	@Prop({ type: String, default: 'primary' }) color!: string
	@Prop({ type: Number }) refId!: number
	@Prop({ type: Number }) situation!: number

	render() {
		return (
			<div class="text-center mb-5">
				<VProgressCircular size="50" rotate="-90" value={this.value} color={this.color} class="mr-1">
					{this.image && <VImg src={this.image} height="26" width="26" aspect-ratio="1.5"></VImg>}
				</VProgressCircular>
				<br />
				<span>{Number(this.value).toFixed(0)}%</span>
			</div>
		)
	}

	async updatePreAnalysisSituation() {
		let status = {
			scoreId: this.refId,
			situacaoPreAnalise: SituacaoPreAnalise.PROPOSTA_NAO_GERADA,
			statusPreAnalise: 1
		}
		if (this.refId) await CreditoImobiliarioService.updatePreAnalysisSituation(this.refId, status)
	}

	@Watch('value')
	onChangeRefId(val: any) {
		if (this.value == 100 && this.situation !== SituacaoPreAnalise.PROPOSTA_GERADA) {
			this.updatePreAnalysisSituation()
		}
	}
}

export default ProgressoForm
